module.exports = __webpack_public_path__ + "static/img/local-verkaufen-img.cd65d4a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/base/local-verkaufen-img.jpeg
// module id = uFmk
// module chunks = 1